// frontend/src/components/layout/PublicNav/PublicNav.tsx

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import './PublicNav.css';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

const NAV_ITEMS: NavItem[] = [
  { path: '/', label: 'Início', icon: '🏠' },
  { path: '/empresas', label: 'Empresas', icon: '🏢' },
  { path: '/ciencia', label: 'Ciência', icon: '🔬' },
  { path: '/governanca', label: 'Governança', icon: '🛡️' },
];

export const PublicNav: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  return (
    <header className="public-nav">
      <div className="public-nav-inner">
        <Link to="/" className="public-nav-logo">
          <span className="public-nav-logo-icon">📊</span>
          <span className="public-nav-logo-text">AutoSAGE</span>
        </Link>

        <nav className="public-nav-links">
          {NAV_ITEMS.map((item) => {
            const isActive =
              item.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`public-nav-link ${isActive ? 'active' : ''}`}
              >
                <span className="public-nav-link-icon">{item.icon}</span>
                <span className="public-nav-link-label">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="public-nav-actions">
          {isAuthenticated ? (
            <Link to="/dashboard" className="public-nav-btn primary">
              📊 Ir para o Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="public-nav-btn secondary">
                🔐 Entrar
              </Link>
              <Link to="/register" className="public-nav-btn primary">
                🚀 Criar conta
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};